import { customTV } from '../../utils/tailwind';
export const chip = customTV({
    base: [
        'inline-flex',
        'items-center',
        'justify-center',
        'rounded-8',
        'box-border',
        'min-h-7',
        'text-14',
        'p-6',
        'focus:outline-none',
        'focus-visible:shadow-[0_0_0_1px_theme(colors.content-default)]',
        'dark:focus-visible:shadow-[0_0_0_1px_theme(colors.content-default-dark)]',
    ],
    variants: {
        avatar: { true: 'p-4' },
        noWrap: { true: 'whitespace-nowrap' },
        asButton: {
            true: 'cursor-pointer border-none outline-none',
        },
        disabled: { true: 'cursor-not-allowed' },
    },
    compoundVariants: [{ disabled: false, asButton: true, className: 'hover:brightness-95' }],
});
export const chipAction = customTV({
    base: 'mx-2 my-0 border-none bg-none p-0 hover:cursor-pointer hover:brightness-75',
});
export const chipIcon = customTV({
    base: 'svg-children:stroke-content-default dark:svg-children:stroke-content-default-dark',
    variants: {
        disabled: {
            true: 'svg-children:stroke-content-disabled dark:svg-children:stroke-content-disabled-dark',
        },
    },
});
